import {Hydra} from '../generic/hydra';

import {AideInterface} from './Aide';
import {UtilisateurInterface} from './Utilisateur';
import {CommissionSeanceInterface} from './CommissionSeance';
import {DossierExpertInterface} from './DossierExpert';
import {DossierMouvementInterface} from './DossierMouvement';
import {DecisionInterface} from './Decision';
import {FormulaireSaisieInterface} from './FormulaireSaisie';
import {LienInteretInterface} from './LienInteret';
import {DeclarationLienInteretInterface} from './DeclarationLienInteret';
import {DossierTranslationInterface} from './DossierTranslation';
import {DossierAnnexeInterface} from './DossierAnnexe';
import {DossierArchiveInterface} from './DossierArchive';
import {FichierInterface} from './Fichier';
import {DossierSnapshotInterface} from './DossierSnapshot';
import {Dossier as DossierBaseInterface} from '../../interface/api/Dossier';
import {VentilationFinanciere} from "../../interface/api/VentilationFinanciere";
import {Cofinanceur} from "../../interface/api/Cofinanceur";
import {PersonneInterface} from "./Personne";
import {DossierExpertSuggestion} from "./DossierExpertSuggestion";

export type DossierInterface = DossierBaseInterface;

export enum StatutFinancement {
    STATUT_FINANCEMENT_ENGAGE = 1,
    STATUT_FINANCEMENT_EN_COURS = 2,
    STATUT_FINANCEMENT_CLOTURE = 3,
    STATUT_FINANCEMENT_COFINANCEUR = 99,
}

export class Dossier extends Hydra implements DossierInterface {

    id?: number | null;

    finId?: number | null;

    numeroDossier?: string | null;

    /* Objet de type Aide
     */
    aide?: AideInterface | string | null;

    /* Objet de type Utilisateur
     */
    candidat?: UtilisateurInterface | string | null;

    commissionSeances?: (CommissionSeanceInterface | string)[] | null = [];

    dateCreation?: string | Date | null;

    dateDerniereModification?: string | Date | null;

    dateValidation?: string | Date | null;

    dateDesistement?: string | Date | null;

    dossierExperts?: DossierExpertInterface[] | string[] | null = [];
    expertisesClassiques?: DossierExpertInterface[] | string[] | null = [];
    monExpertiseClassique?: DossierExpertInterface|null;

    dossierMouvements?: DossierMouvementInterface[] | string[] | null = [];

    decisions?: DecisionInterface[] | string[] | null = [];

    formulaireSaisieCandidat?: FormulaireSaisieInterface | string | null;

    /* 0,1,2,3,4,5,6,7,8,9,10
     */
    statut?: number | null = 0;

    lienInterets?: LienInteretInterface[] | string[] | null = [];

    lienInteretsDateCalcul?: string | Date | null;

    declarationLienInterets?: DeclarationLienInteretInterface[] | string[] | null = [];

    lienInteretsStatutCalcul?: number | null;

    translations?: DossierTranslationInterface[] | null = [];

    /* READ ONLY ! Utiliser API dédiée pour créer / supprimer des annexes
     */
    annexes?: DossierAnnexeInterface[] | string[] | null = [];

    /* non consultable sur AAP, uniquement pour finance
     */
    archives?: DossierArchiveInterface[] | string[] | null = [];

    dossierPrecedent?: any | null;

    dossierSuivant?: any | null;

    duplicated?: boolean | null;

    ajustementsNumber?: number | null;

    commentaireDS?: string | null;

    reponseCandidat?: string | null;

    statutFinancement?: number | null;

    organization?: number | null;

    organizationName?: string | null;

    dateSelectionOrganization?: string | Date | null;

    conditionsGenerales?: FichierInterface | string | null;

    ribChercheur?: FichierInterface | string | null;

    ficheEquipe?: FichierInterface | string | null;

    snapshots?: DossierSnapshotInterface[] | string[] | null = [];

    annee?: string | null;

    calculerLiensInteretsAutorise?: boolean | null = false;

    dateAcceptation?: string | null;
    dateDebutFinancement?: string | null;

    dateFinFinancement?: string | null;

    montantFinance?: number | null;

    dureeProlongation?: number | null;
    dureeAccordeeFinancement?: number | null;

    dureeReelle?: number | null;

    ventilationFinanciereInitiale?: VentilationFinanciere | null;
    ventilationFinanciereActuelle?: VentilationFinanciere | null;

    financeur?: Cofinanceur | null;

    dossierOrigine?: DossierInterface | null;

    porteur?: PersonneInterface | null;

    suggestionExperts?: DossierExpertSuggestion[] | null;

    constructor(options: DossierInterface = null) {
        super();
        if (options) {
            Object.assign(this, options);
        }
    }

}
